import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch {
      setError('Ocurrió un error. Por favor intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image">
        <div className="login-brand-mark">
          <div className="login-brand-lockup">
            <span className="login-brand-name"><span className="accent">R</span>ENATA</span>
            <span className="login-brand-divider"></span>
            <span className="login-brand-sibling">TAXI</span>
          </div>
          <p className="login-brand-tagline">Taxi es la plataforma de gestión de EFE Company, hermana de Renata, tu asistente tributaria con IA.</p>
        </div>
      </div>
      <div className="login-form-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2><span className="accent-text">TAXI</span> te lleva al futuro de la contabilidad</h2>
          <p>Recuperar contraseña</p>

          {submitted ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ color: '#ffd700', marginBottom: '16px' }}>
                Si el correo está registrado, recibirás un email con instrucciones en los próximos minutos.
              </p>
              <p style={{ fontSize: '13px', color: '#71717a' }}>
                Revisa también tu carpeta de spam.
              </p>
              <Link to="/login" style={{ display: 'block', marginTop: '16px', color: '#ffd700' }}>
                Volver al login
              </Link>
            </div>
          ) : (
            <>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Ingresa tu correo"
                required
              />
              {error && <p style={{ color: '#f87171', fontSize: '13px' }}>{error}</p>}
              <button type="submit" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar instrucciones'}
              </button>
              <Link to="/login" className="forgot-password">Volver al login</Link>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
